import { flow, Instance, types } from "mobx-state-tree";

import { globalModule } from "../service-provider/GlobalModule";
import { registerGlobalService } from "../service-provider/ServiceRegistry";
import { LoggerModel } from "../loggers/LoggerModel";

export const NetworkStatusModel = types
  .model({
    online: types.optional(types.boolean, true),
    logger: types.optional(LoggerModel, {
      enabled: true,
    }),
  })
  .actions((self) => ({
    checkOnlineStatus: flow(function* _checkOnlineStatus() {
      try {
        const fetchResult = yield fetch("/1pixelImage.png", {
          cache: "no-store",
        });
        self.online = fetchResult.status >= 200 && fetchResult.status < 300;
      } catch (err) {
        self.online = false;
      }
    }),
  }))
  .actions((self) => {
    return {
      afterCreate() {
        setInterval(() => {
          self.checkOnlineStatus();
        }, 10 * 1000);
      },
    };
  });

export type NetworkStatusService = Instance<typeof NetworkStatusModel>;
export const networkStatus = NetworkStatusModel.create();
globalModule.networkStatusService = networkStatus;
export default registerGlobalService(networkStatus as NetworkStatusService);
